module.exports = __webpack_public_path__ + "img/shot_img112103.db29f494.gif";